let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Zc8l")).then(() => parcelRequire('49lxd'));